"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipelineStage = exports.Stage = void 0;
// Application environment constants
var Stage;
(function (Stage) {
    Stage["Local"] = "local";
    Stage["Dev"] = "dev";
    Stage["Beta"] = "beta";
    Stage["Gamma"] = "gamma";
    Stage["Prod"] = "prod";
})(Stage || (exports.Stage = Stage = {}));
var PipelineStage;
(function (PipelineStage) {
    PipelineStage["Beta"] = "beta";
    PipelineStage["Gamma"] = "gamma";
    PipelineStage["Prod"] = "prod";
})(PipelineStage || (exports.PipelineStage = PipelineStage = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2luZnJhLWNvbnN0L2NvbW1vbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvQ0FBb0M7QUFDcEMsSUFBWSxLQU9YO0FBUEQsV0FBWSxLQUFLO0lBRWIsd0JBQWUsQ0FBQTtJQUNmLG9CQUFXLENBQUE7SUFDWCxzQkFBYSxDQUFBO0lBQ2Isd0JBQWUsQ0FBQTtJQUNmLHNCQUFhLENBQUE7QUFDakIsQ0FBQyxFQVBXLEtBQUsscUJBQUwsS0FBSyxRQU9oQjtBQUVELElBQVksYUFLWDtBQUxELFdBQVksYUFBYTtJQUVyQiw4QkFBaUIsQ0FBQTtJQUNqQixnQ0FBbUIsQ0FBQTtJQUNuQiw4QkFBaUIsQ0FBQTtBQUNyQixDQUFDLEVBTFcsYUFBYSw2QkFBYixhQUFhLFFBS3hCIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQXBwbGljYXRpb24gZW52aXJvbm1lbnQgY29uc3RhbnRzXG5leHBvcnQgZW51bSBTdGFnZVxue1xuICAgIExvY2FsID0gXCJsb2NhbFwiLFxuICAgIERldiA9IFwiZGV2XCIsXG4gICAgQmV0YSA9IFwiYmV0YVwiLFxuICAgIEdhbW1hID0gXCJnYW1tYVwiLFxuICAgIFByb2QgPSBcInByb2RcIixcbn1cblxuZXhwb3J0IGVudW0gUGlwZWxpbmVTdGFnZVxue1xuICAgIEJldGEgPSBTdGFnZS5CZXRhLFxuICAgIEdhbW1hID0gU3RhZ2UuR2FtbWEsXG4gICAgUHJvZCA9IFN0YWdlLlByb2QsXG59Il19